var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.voters),function(voter){return _c('basic-info',{key:voter.member_id,attrs:{"name":voter.full_name,"profilePictureURL":voter.link}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }